var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinervaIoTLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MinervaIoT_Logo",
    "data-name": "MinervaIoT Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.609,
    height: 9.365,
    viewBox: "0 0 79.609 9.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#474b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#5f8f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70c143"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 1.366,
    height: 9.323,
    transform: "translate(12.489 0.004)",
    fill: "#474b4f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M159.619,1109.689v-4.937l1.321-1.315v6.255Zm-7.191-5.754v5.779H151.18v-9.325l4.875,4.809,4.875-4.809v2.039l-4.875,4.868Z",
    transform: "translate(-151.18 -1100.385)",
    fill: "#474b4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M398.22,1109.679v-6.255l1.366,1.6v4.655Zm0-7.261v-2.038l6.565,7.768v-7.768h1.4v9.323h-1.707Z",
    transform: "translate(-381.799 -1100.376)",
    fill: "#474b4f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 1.366,
    height: 9.323,
    transform: "translate(26.874 0.004)",
    fill: "#474b4f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 4.194,
    height: 1.407,
    transform: "translate(28.958 0.004)",
    fill: "#474b4f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 4.194,
    height: 1.382,
    transform: "translate(28.958 4.05)",
    fill: "#474b4f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 4.194,
    height: 1.407,
    transform: "translate(28.958 7.921)",
    fill: "#474b4f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(61.672 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M1134.244,1130a3.686,3.686,0,0,1,3.7,3.707,3.591,3.591,0,0,1-.288,1.432,3.679,3.679,0,0,1-1.966,1.963,3.731,3.731,0,0,1-2.887,0,3.691,3.691,0,0,1-1.961-1.963,3.584,3.584,0,0,1-.289-1.432,3.693,3.693,0,0,1,2.249-3.417,3.6,3.6,0,0,1,1.442-.29Zm0,6.359a2.42,2.42,0,0,0,1-.209,2.613,2.613,0,0,0,.819-.569,2.681,2.681,0,0,0,.551-.843,2.653,2.653,0,0,0,.2-1.033,2.687,2.687,0,0,0-.2-1.038,2.723,2.723,0,0,0-.551-.851,2.571,2.571,0,0,0-.819-.574,2.421,2.421,0,0,0-1-.21,2.391,2.391,0,0,0-.991.21,2.586,2.586,0,0,0-.813.574,2.722,2.722,0,0,0-.551.852,2.682,2.682,0,0,0-.2,1.038,2.646,2.646,0,0,0,.2,1.033,2.683,2.683,0,0,0,.551.843,2.636,2.636,0,0,0,.813.569,2.381,2.381,0,0,0,.991.209Z",
    transform: "translate(-1127.123 -1128.031)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 1.411,
    height: 9.323,
    transform: "translate(13.471)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 1.411,
    height: 9.323,
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 2.449,
    height: 1.286,
    transform: "translate(10.416)",
    fill: "#70c143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 2.449,
    height: 1.286,
    transform: "translate(15.488)",
    fill: "#70c143"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M692.276,1100.364v9.311H690.91v-9.311Zm5.581,9.324h-1.764l-3.117-4.04h1.461a1.988,1.988,0,0,0,2.161-1.951,2.046,2.046,0,0,0-2.161-2.048h-1.461v-1.288h1.3a3.292,3.292,0,0,1,3.536,3.32,3.15,3.15,0,0,1-2.272,3.093Z",
    transform: "translate(-655.033 -1100.361)",
    fill: "#474b4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M937.022,1100.38l4.084,9.323h-1.52l-2.562-5.665-2.562,5.665h-1.52Zm.668,7.9h-1.321v1.419h1.321Z",
    transform: "translate(-880.976 -1100.376)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M819.864,1109.7l-4.084-9.323h1.52l2.562,5.665,2.562-5.665h1.522Z",
    transform: "translate(-771.603 -1100.375)",
    fill: "#474b4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaIoTLogo);
export default __webpack_public_path__ + "static/media/MinervaIoT_Logo.802cbec433a2af22ae1424cdb53edc70.svg";
export { ForwardRef as ReactComponent };